import { faCircleInfo } from '@fortawesome/pro-light-svg-icons'
import { memo } from 'react'
import {
  BWOutsideLink,
  BWPageContent,
  BWPanel,
  BWPanelContent,
  BWText,
  BW_LABEL_TEXT
} from 'src/libs/qb-brand-web-components'

import brandConfig from 'brandConfig'
import PageHeaderWrapper from 'wrappers/PageHeaderWrapper'
import TermsPoliciesWrapper from 'wrappers/TermsPoliciesWrapper'

const ContactUs = ({ t, color, customCss }) => {
  const supportEmail = brandConfig.faqEmail
  return (
    <>
      <PageHeaderWrapper
        label={t('brand:user.contact-us.page-title')}
        icon={faCircleInfo}
        header
      />
      <BWPageContent>
        <BWPanel color={color} css={customCss}>
          <BWText
            alignCenter
            label={t('brand:user.contact-us.we-want-to-hear-from-you')}
            size={18}
            weight={700}
          />
          <BWPanelContent>
            <BWText
              alignCenter
              label={t('brand:user.contact-us.feedback-intro')}
            />
            <BWText
              alignCenter
              label={
                <BWOutsideLink isEmail label={supportEmail} to={supportEmail} />
              }
            />
          </BWPanelContent>
          <BWPanelContent>
            <BWText alignCenter label={t('brand:user.contact-us.help-intro')} />
            <BWText
              alignCenter
              label={
                <BWOutsideLink isEmail label={supportEmail} to={supportEmail} />
              }
            />
          </BWPanelContent>
          <BWText
            alignCenter
            label={
              <TermsPoliciesWrapper
                t={t}
                i18nKey={BW_LABEL_TEXT.VIEW_TERMS_POLICY}
              />
            }
          />
        </BWPanel>
      </BWPageContent>
    </>
  )
}

export default memo(ContactUs)
